// ハンバーガーメニュー追従
$(function(){

  var tageSelector = '.js-mobile-menu-icon';
  var tageWrapperSelector = '.hamburguer-btn-wrap';
  var fixedClass = 'is-fixed';
  var gap = 20;

  $(tageSelector).each(function(){

    var tagePosY = $(tageWrapperSelector).offset().top;
    var tagePosX = $(tageWrapperSelector).offset().left;

    $(window).on('load scroll resize', function() {
        tagePosY = $(tageWrapperSelector).offset().top;
        tagePosX = $(tageWrapperSelector).offset().left;

        var scrollY = $(this).scrollTop();

        if (scrollY > tagePosY - gap) {
          $(tageSelector).addClass(fixedClass);
          $(tageSelector).css({
              'top': gap + 'px',
              'left': tagePosX + 'px'
          });
        } else {
          $(tageSelector).removeClass(fixedClass);
        }
    });

  });

});